import React, { useContext, useState } from 'react';
import loadable from '@loadable/component';

const EventContext = React.createContext();

function useEventContext() {
  return useContext(EventContext);
}

// eslint-disable-next-line react/prop-types
const EventContextProvider = ({ children, configuration }) => {
  const [EffectiveContextProvider, setEffectiveContextProvider] = useState();

  if (!configuration) {
    return (
      <EventContext.Provider
        value={{ createEvent: () => { }, createEcommerceEvent: () => { }, getEventHistory: () => { }, removeEventFromLog: () => { } }}
      >
        {children}
      </EventContext.Provider>
    );
  }

  if (!EffectiveContextProvider) {
    // eslint-disable-next-line react/prop-types
    if (configuration?.config?.events?.provider === 'ga') {
      setEffectiveContextProvider(
        loadable(() => import('@nextgen/frontend-features-events-google-analytics'), {
          resolveComponent: loaded => loaded.GAContextProvider
        })
      );
    }
    if (!EffectiveContextProvider)
      return (
        <EventContext.Provider
          value={{ createEvent: () => { }, createEcommerceEvent: () => { }, getEventHistory: () => { }, removeEventFromLog: () => { } }}
        >
          {children}
        </EventContext.Provider>
      );
  }

  return (
    <EffectiveContextProvider provider={EventContext.Provider} configuration={configuration}>
      {children}
    </EffectiveContextProvider>
  );
};

export { EventContextProvider, useEventContext };
